import React, { useEffect, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import { CustomTypography } from "../../custom-typography/custom-typography";
import { useStatisticsStore } from "../../../stores/statisticsStore";
import { BlockModalWrapper } from "../../../components/block-modal-wrapper/block-modal-wrapper";
import { FullScreenImage } from "../../chat/chat-bubble/image-messages/full-screen-image/full-screen-image";
import { AuthenticatedImage } from "../../authenticated-media/authenticated-image";
import {
  certificatesContainerStyles,
  certificatesListStyles,
  certificateImageStyles,
} from "./styles";

export const CertificatesCard: React.FC = () => {
  const {
    certificates,
    isLoadingCertificates,
    errorCertificates,
    fetchCertificates,
  } = useStatisticsStore();

  const [isFullScreenOpen, setIsFullScreenOpen] = useState(false);
  const [selectedCert, setSelectedCert] = useState<string>("");

  useEffect(() => {
    fetchCertificates();
  }, [fetchCertificates]);

  const handleCertClick = (certUrl: string) => {
    setSelectedCert(certUrl);
    setIsFullScreenOpen(true);
  };

  const handleCloseFullScreen = () => {
    setIsFullScreenOpen(false);
  };

  return (
    <BlockModalWrapper lable={"Certificates"} md={1}>
      <Box sx={certificatesContainerStyles}>
        {isLoadingCertificates ? (
          <Box sx={certificatesListStyles}>
            {Array.from({ length: 1 }).map((_, idx) => (
              <Skeleton
                key={idx}
                variant="rectangular"
                animation="wave"
                sx={{
                  ...certificateImageStyles,
                  height: "285px",
                }}
              />
            ))}
          </Box>
        ) : errorCertificates ? (
          <CustomTypography color="red">{errorCertificates}</CustomTypography>
        ) : (
          <Box sx={certificatesListStyles}>
            {certificates.map((certUrl, idx) => (
              <AuthenticatedImage
                key={idx}
                src={certUrl}
                alt={`Certificate ${idx + 1}`}
                sx={certificateImageStyles}
                onClick={() => handleCertClick(certUrl)}
              />
            ))}
          </Box>
        )}
      </Box>
      <FullScreenImage
        open={isFullScreenOpen}
        onClose={handleCloseFullScreen}
        src={selectedCert}
        alt="Certificate"
      />
    </BlockModalWrapper>
  );
};

export default CertificatesCard;
